import * as actions from 'actions';

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.CHAT_MESSAGE_UPDATE_WRITING_INDICATOR: {
      return action.isWriting;
    }

    default:
      return state;
  }
};




/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatWritingIndicator/reducer.js
 **/